
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerUser/create",
      function () {
        return require("private-next-pages/partnerUser/create.tsx");
      }
    ]);
  